export default __webpack_public_path__ + "static/media/bookmark-bg-icon.38c594d6.svg";